import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { ProposalTotals } from "../types/proposal";
import { formatCurrency } from "../utils/currency";

type Props = {
  totals: ProposalTotals;
};

const SummaryLine = ({
  label,
  value,
  color,
}: {
  label: string;
  value: string;
  color?: "error" | "text.primary";
}) => (
  <Stack direction="row" justifyContent="space-between" gap={2}>
    <Typography color="text.secondary">{label}</Typography>
    <Typography fontWeight={600} color={color}>
      {value}
    </Typography>
  </Stack>
);

const SummaryCard: React.FC<Props> = ({ totals }) => (
  <Card>
    <CardHeader title="Resumo" />
    <CardContent>
      <Stack spacing={1.5}>
        <SummaryLine label="Subtotal" value={formatCurrency(totals.subtotal)} />
        <SummaryLine label="Frete" value={formatCurrency(totals.freight)} />
        <SummaryLine
          label="Desconto"
          value={`- ${formatCurrency(totals.discount)}`}
          color={totals.discount ? "error" : "text.primary"}
        />
        <Divider />
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">TOTAL</Typography>
          <Typography variant="h5" color="primary" fontWeight={800}>
            {formatCurrency(totals.total)}
          </Typography>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);

export default SummaryCard;
